import $ from 'jquery';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import EmoticonsStore from '../stores/EmoticonsStore';
import get from 'lodash/get';

const ActionTypes = Constants.ActionTypes;

const requestPage = function (id) {
  const url = `${get(globals, 'apiWebroot', '')}smileys/page/${id}`;

  const ajaxGet = $.ajax({
    type: 'GET',
    url,
    dataType: 'json',
  });

  return ajaxGet;
};

module.exports = {
  loadEmoticonsPage(page_id) {
    const data = EmoticonsStore.getPage(page_id);
    if (data) {
      AppDispatcher.dispatch({
        type: ActionTypes.EMOTICONS_LOAD_SUCCESS,
        data,
        pageId: page_id,
      });
      return;
    }

    AppDispatcher.dispatch({
      type: ActionTypes.EMOTICONS_LOAD,
      pageId: page_id,
      loading: true,
    });

    const request = requestPage(page_id);

    // success
    request.done((data) => {
      AppDispatcher.dispatch({
        type: ActionTypes.EMOTICONS_LOAD_SUCCESS,
        data,
        pageId: page_id,
      });
    });

    // fail
    request.fail((data) => {
      AppDispatcher.dispatch({
        type: ActionTypes.EMOTICONS_LOAD_FAIL,
        data,
      });
    });
  },
};
